module.exports = __webpack_public_path__ + "img/21_ileocecal-valve.8665af08.png";